var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back ml10",on:{"click":_vm.goBack}},[_c('i',{staticClass:"icon iconfont el-icon-arrow-left"})])
}
var staticRenderFns = []

export { render, staticRenderFns }